module.exports = __webpack_public_path__ + "img/ch_bt_luckydraw_gif.75e735a8.png";